import { createFileRoute } from '@tanstack/react-router';

import { ConnectDataScreen } from '@/screens/onboarding/ConnectDataScreen';

export const Route = createFileRoute('/_onboarding/onboarding/connect-data')({
  component: ConnectDataScreen,
});
